'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'poo-storm';
var width = 512;
var height = 512;
var aliases = ["poo-bolt"];
var unicode = 'f75a';
var svgPathData = 'M262-23.2c6.3-5.7 15.2-7.6 23.3-5 38.7 12.4 66.7 48.7 66.7 91.6 0 5.7-.5 11.2-1.4 16.6l9.4 0c48.6 0 88 39.4 88 88 0 14.8-3.7 28.8-10.2 41.1 42 6.6 74.2 43 74.2 86.9 0 48.6-39.4 88-88 88l-10.1 0c-7.1-26.8-31-46.8-59.8-47.9l0-.1 69.9 0c22.1 0 40-17.9 40-40 0-19.9-14.6-36.5-33.6-39.5l-33.2-5.2c-7.7-1.2-14.3-6-17.7-13s-3.4-15.1 .2-22l15.7-29.7c2.9-5.5 4.6-11.8 4.6-18.6 0-22.1-17.9-40-40-40l-38 0c-7.1 0-13.8-3.1-18.4-8.6s-6.5-12.6-5.3-19.6l4.9-28.1 0 0c.5-2.7 .7-5.5 .7-8.4 0-6.5-1.3-12.8-3.7-18.5-5.9 22.8-18.8 41.9-36.8 55.9-24.4 19-55.9 27.2-87.5 27.2l-24 0c-22.1 0-40 17.9-40 40 0 6.8 1.7 13.1 4.6 18.6l15.7 29.7c3.6 6.8 3.7 15 .2 22s-10.1 11.8-17.7 13l-33.2 5.2c-19 3-33.6 19.6-33.6 39.5 0 22.1 17.9 40 40 40l46.6 0-17.1 15.3c-9.8 8.8-16.6 20.2-19.7 32.7L88 384c-48.6 0-88-39.4-88-88 0-43.9 32.1-80.3 74.2-86.9-6.5-12.3-10.2-26.2-10.2-41.1 0-48.6 39.4-88 88-88l24 0c24 0 44.2-6.3 58.1-17 13.4-10.4 21.9-25.9 21.9-47.6 0-5.5-.5-10.8-1.6-15.9-1.7-8.3 1.2-16.9 7.5-22.6zM160.6 416c-9.2 0-16.6-7.4-16.6-16.6 0-4.7 2-9.2 5.5-12.4L290.7 260.7c3.4-3 7.8-4.7 12.4-4.7 12.4 0 21.3 12 17.8 23.9l-31.2 104.1 61.8 0c9.2 0 16.6 7.4 16.6 16.6 0 4.7-2 9.2-5.5 12.4L221.3 539.3c-3.4 3-7.8 4.7-12.4 4.7-12.4 0-21.3-12-17.8-23.9l31.2-104.1-61.8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPooStorm = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;